import { render, staticRenderFns } from "./PlumbNodeEditor.vue?vue&type=template&id=61723c6c&"
import script from "./PlumbNodeEditor.vue?vue&type=script&lang=ts&"
export * from "./PlumbNodeEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports